var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5A239",
    fillRule: "evenodd",
    d: "M8.054 1.348c1.586 0 2.88 1.249 2.954 2.817l.003.14v.621a.5.5 0 0 1-.996.068l-.004-.068v-.622a1.957 1.957 0 0 0-1.842-1.953l-.115-.003h-3.25a1.957 1.957 0 0 0-1.953 1.841l-.003.115v7.42c0 1.042.815 1.894 1.841 1.954l.115.003h3.257a1.95 1.95 0 0 0 1.947-1.835l.003-.114v-.629a.5.5 0 0 1 .995-.068l.005.068v.629a2.95 2.95 0 0 1-2.807 2.946l-.143.003H4.804a2.957 2.957 0 0 1-2.953-2.817l-.003-.14v-7.42c0-1.586 1.25-2.88 2.817-2.953l.14-.003h3.25Zm7.332 6.305a.499.499 0 0 1-.003.725l-1.943 1.934a.5.5 0 0 1-.754-.652l.049-.056 1.093-1.09H7.012a.5.5 0 0 1-.067-.995l.067-.005h6.817l-1.094-1.089a.5.5 0 0 1-.05-.65l.048-.057a.5.5 0 0 1 .651-.05l.056.049 1.946 1.936Z",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;